import { css } from "styled-components"

import { device } from "utils"

const richTextBody = () => css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  li,
  a {
    color: var(--primary-font-color);
  }

  h2,
  h3,
  h4 {
    margin-bottom: var(--sp-16);
  }

  p {
    margin-bottom: var(--sp-16);
    white-space: break-spaces;

    @media ${device.laptop} {
      margin-bottom: var(--sp-32);
    }
  }

  blockquote {
    @media ${device.laptop} {
      margin-bottom: var(--sp-32);
      margin-top: 0;
    }
    p {
      font-family: var(--title-font-family);
      color: #6270d2;
      max-width: 580px;

      text-align: left;
      /* 20px */
      font-size: 1.25rem;
      line-height: 32px;
    }
  }

  ul,
  ol {
    list-style: initial;
    padding-left: 30px;
    margin-bottom: var(--sp-16);

    @media ${device.laptop} {
      margin-bottom: var(--sp-32);
    }
    p {
      margin-bottom: 0;
    }
  }

  ol {
    list-style: decimal;
  }

  img {
    width: 100%;
    border-radius: var(--card-radius);
  }

  a {
    /* 14px */
    font-size: 0.875rem;
    line-height: 22px;

    display: inline-block;
    word-break: break-all;
    word-wrap: break-word;

    @media ${device.laptop} {
      /* 20px */
      font-size: 1.25rem;
      line-height: 30px;
    }
  }

  i {
    font-style: italic;
  }
  strong {
    font-weight: 700;
  }

  .richText_media,
  .videoWrap {
    margin-bottom: var(--sp-16);

    @media ${device.laptop} {
      margin-bottom: var(--sp-32);
    }
  }

  table {
    width: 100%;
    display: block;

    th,
    td {
      font-weight: normal;
      font-family: "Inter";
      color: var(--card-shade_3);
      padding: var(--sp-8);
      border: 1px solid var(--card-shade_3);

      min-width: 120px;
      /* 12px */
      font-size: 0.75rem;
      @media ${device.laptop} {
        min-width: auto;
        padding: var(--sp-12);
        /* 14px */
        font-size: 0.875rem;
      }
    }

    th {
      font-weight: 500;
    }

    td {
      line-height: 16px;
    }
  }
`

export default richTextBody
